import { c as _c } from "react/compiler-runtime";
import type { TranslationDetails } from 'bnef';
import type { FC } from 'react';
interface IMachineTranslationDisclaimerProps {
  id: string;
  translationDetails?: TranslationDetails;
}
export const MachineTranslationDisclaimer: FC<IMachineTranslationDisclaimerProps> = t0 => {
  const $ = _c(3);
  const {
    id,
    translationDetails
  } = t0;
  if (!translationDetails?.isAutomaticProvider) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <small>This content has been translated automatically using machine translation and may contain inaccuracies or errors. The translation is provided for convenience only and has not been independently verified. In the event of any discrepancy between this translation and the original English-language version, the English-language version will prevail. No warranty of any kind, express or implied, is made as to the accuracy, reliability or completeness of any translation from English into another language. To the maximum extent permitted by law, Bloomberg Finance L.P. and its affiliates disclaim any liability arising from or relating to the use of, or reliance on, any such translation.</small>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== id) {
    t2 = <p id={id}>{t1}</p>;
    $[1] = id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};